<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
        <ChangePasswordUser :user="selectedUser" @clearSelectedUser="clearSelectedPromotor"
                            v-model="showChangePasswordUserDialog"/>
        <DeletePromotor v-model="showDeletePromotorDialog"/>
        <NewEditPromotor/>
        <view-user :auths="authsSelectedUser"
                   :user-id="selectedUser"
                   v-model="viewUserDialog"
                   @clearUserIdAndAuths="clearUserIdAndAuths()"
                   @getUsers="getPromotors()"/>

        <!-- UploadPromotorProfilePhoto -->
        <UploadPromotorImagen
          :showUploadImageDialog="showSetPromotorProfilePhoto"
          :loadingUploadImage="uploadingPromotorProfilePhoto"
          :mainLabel="$t('general.profileImage')" :secondaryLabel="$t('general.thePicture')"
          formFileFieldName="promotor-profile-photo"
          methodToDispatchUpload="uploadPromotorProfilePhoto"
          @toggleShowUploadImageDialog="(value)=>{showSetPromotorProfilePhoto = value}"/>

        <!-- UploadPromotorBannerPhoto -->
        <UploadPromotorImagen
          :showUploadImageDialog="showSetPromotorBannerPhoto"
          :loadingUploadImage="uploadingPromotorBannerPhoto"
          mainLabel="Banner" :secondaryLabel="$t('general.theBanner')"
          formFileFieldName="promotor-banner-photo"
          methodToDispatchUpload="uploadPromotorBannerPhoto"
          @toggleShowUploadImageDialog="(value)=>{showSetPromotorBannerPhoto = value}"/>

        <AttachPromotorUrl/>

        <v-col cols="12" class="d-flex justify-space-between align-center">
            <v-text-field :hint="$t('general.search')"
                          @input="showOptions = false"
                          clearable
                          class="mr-3"
                          color="kbDarkBlue"
                          :placeholder="$t('general.search')"
                          v-model="search">
                <template v-slot:append-outer>
                    <v-icon color="kbDarkBlue" @click="getPromotors" class="ml-2">refresh</v-icon>
                </template>
            </v-text-field>

            <v-tooltip :disabled="companyBlocked" bottom>
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-btn :disabled="companyBlocked"
                               dark
                               @click="showCreatePromotor"
                               color="kbPurple">
                            {{ $t('general.createPromotor') }}
                        </v-btn>
                    </div>
                </template>
                <span>{{ companyBlocked ? $t('general.mustChargeBeforeCreatingPromotors') : $t('general.createPromotor') }}</span>
            </v-tooltip>
        </v-col>

        <v-col class="text-h6" cols="12">
            <v-data-table class="elevation-2"
                          :headers="headers"
                          :items="promotors"
                          :loading="loadingPromotors"
                          :options.sync="optionsPromotors"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.promotors')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalPromotors">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="font-weight-bold text-capitalize">{{ item.name || $t('general.noName') }}</td>
                    <td>{{ item.email || item.phone }}</td>
                    <td>{{ item.UUID }}</td>
                    <td class="text-center" style="min-width: 130px">
                        <v-tooltip bottom v-if="item.isImported">
                            <template v-slot:activator="{ on }">
                                <v-icon class="mx-1"
                                        color="primary"
                                        small
                                        style="cursor: pointer;"
                                        v-on="on">
                                    cloud_upload
                                </v-icon>
                            </template>
                            <span>{{ $t('general.imported') }}</span>
                        </v-tooltip>
                        <v-icon class="mx-1" color="primary"
                                small
                                v-else-if="item.auths && item.auths.length === 0">
                            {{item.phone ? 'phone' : 'mail'}}
                        </v-icon>

                        <v-icon :key="index"
                                class="mx-1"
                                color="kbDarkBlue"
                                small
                                v-for="(item, index) in item.auths">
                            fab fa-{{item.provider.name}}
                        </v-icon>
                    </td>
                    <td align="right">{{ item.status }}</td>
                    <td align="right">{{ item.ranking }}</td>
                    <td align="right">{{ item.soldTickets }}</td>
                    <td align="right">{{ item.location }}</td>
                    <td align="right">{{ item.balance }}</td>
                    <td align="right">{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mma') }}</td>
                    <td class="ma-0 pa-0">
                      <div class="data-table-actions d-flex justify-center align-center">
                        <v-btn @click="showUser(item)" color="kbDarkBlue" text icon>
                            <v-icon>remove_red_eye</v-icon>
                        </v-btn>

                        <v-menu>
                            <template v-slot:activator="{ on }">
                                <v-btn color="kbDarkBlue" text icon v-on="on">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="showUrlToPromotor(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">attachment</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.showUrlToPromotor') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showEditPromotor(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">edit</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.editPromotor') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showSetProfilePhoto(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">account_box</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.setProfilePicture') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showSetBannerPhoto(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">mdi-book-account</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.setBanner') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showOneTimePassword(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">looks_one</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.oneTimePassword') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showChangePasswordUser(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">vpn_key</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.changePassword') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showDeletePromotor(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">delete</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.deletePromotor') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                      </div>
                    </td>
                  </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" v-if="loadingPromotors" cols="12">
                            {{ $t('general.loadingPromotors') }}
                        </v-col>
                        <v-col class="red--text text-center" v-else cols="12">
                            {{ $t('general.noPromotorsRegistered') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import CreateList from '@/pages/App/People/dialogs/CreateList.vue'
import DeletePromotor from '@/pages/App/Events/dialogs/DeletePromotor'
// import InviteUser from '@/pages/App/People/dialogs/InviteUser.vue'
// import GuestsDialog from '@/pages/App/People/dialogs/Guests.vue'
// import OneTimePassword from '@/pages/App/People/dialogs/OneTimePassword.vue'
// import SendSms from '@/components/dialogs/SendSms.vue'
import NewEditPromotor from '@/pages/App/Events/dialogs/NewEditPromotor'
import UploadPromotorImagen from '@/pages/App/Events/dialogs/UploadPromotorImagen'
import AttachPromotorUrl from '@/pages/App/Events/dialogs/AttachPromotorUrl'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser'
// import ImporterNew from '@/components/ui/ImporterNew/ImporterNew'
import ChangePasswordUser from '@/pages/App/People/dialogs/ChangePasswordUser'
import TimeZones from '@/mixins/TimeZones'

export default {
  components: {
    ChangePasswordUser,
    // CreateList,
    DeletePromotor,
    // GuestsDialog,
    // ImporterNew,
    // InviteUser,
    // OneTimePassword,
    // SendSms,
    ViewUser,
    NewEditPromotor,
    UploadPromotorImagen,
    AttachPromotorUrl
  },
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp,
      promotors: state => state.events.promotors,
      totalPromotors: state => state.events.totalPromotors,
      loadingPromotors: state => state.events.loadingPromotors,
      uploadingPromotorProfilePhoto: state => state.events.uploadingPromotorProfilePhoto,
      uploadingPromotorBannerPhoto: state => state.events.uploadingPromotorBannerPhoto
    }),
    ...mapGetters(['companyBlocked']),
    search: {
      get () {
        return this.$store.state.users.search
      },
      set (value) {
        this.$store.commit('SET_SEARCH_USERS', value)
      }
    },
    isSearching () {
      return this.search && this.search !== ''
    },
    optionsPromotors: {
      get () {
        return this.$store.state.events.optionsPromotors
      },
      set (value) {
        this.$store.commit('SET_PAGINATION_PROMOTORS', value)
      }
    },
    showNewEditPromotorDialog: {
      get () {
        return this.$store.state.events.showNewEditPromotorDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_EDIT_PROMOTOR_DIALOG', value)
      }
    },
    showSetPromotorProfilePhoto: {
      get () {
        return this.$store.state.events.showSetPromotorProfilePhoto
      },
      set (value) {
        this.$store.commit('SET_SHOW_SET_PROMOTOR_PROFILE_PHOTO', value)
      }
    },
    showSetPromotorBannerPhoto: {
      get () {
        return this.$store.state.events.showSetPromotorBannerPhoto
      },
      set (value) {
        this.$store.commit('SET_SHOW_SET_PROMOTOR_BANNER_PHOTO', value)
      }
    },
    headers () {
      return [
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.emailOrPhone'), value: 'email' },
        { text: 'ID', value: 'UUID' },
        { text: this.$t('general.method'), align: 'center', value: 'auths' },
        { text: this.$t('general.state'), align: 'right', value: 'status' },
        { text: 'Ranking', align: 'right', value: 'ranking' },
        { text: this.$t('general.soldTickets'), align: 'right', value: 'soldTickets' },
        { text: this.$t('general.location'), align: 'right', value: 'location' },
        { text: 'Balance', align: 'right', value: 'balance' },
        { text: this.$t('general.creationDate'), value: 'createdAt' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  created () {
    this.$store.dispatch('getRoles')
  },
  data () {
    return {
      selectedUser: '',
      authsSelectedUser: [],
      showChangePasswordUserDialog: false,
      showDeletePromotorDialog: false,
      viewUserDialog: false
    }
  },
  methods: {
    showCreatePromotor () {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PROMOTOR', 'new')
      this.showNewEditPromotorDialog = true
    },
    clearUserIdAndAuths () {
      this.selectedUser = ''
      this.authsSelectedUser = []
    },
    clearSelectedPromotor () {
      this.selectedUser = undefined
    },
    getPromotors () {
      this.$store.dispatch('getPromotors')
    },
    showUser (user) {
      this.selectedUser = user.UUID
      this.authsSelectedUser = user.auths
      this.viewUserDialog = true
    },
    showSetProfilePhoto (promotor) {
      this.$store.commit('SET_SELECTED_PROMOTOR', promotor)
      this.$store.commit('SET_SHOW_SET_PROMOTOR_PROFILE_PHOTO', true)
    },
    showSetBannerPhoto (promotor) {
      this.$store.commit('SET_SELECTED_PROMOTOR', promotor)
      this.$store.commit('SET_SHOW_SET_PROMOTOR_BANNER_PHOTO', true)
    },
    showUrlToPromotor (promotor) {
      this.$store.commit('SET_SELECTED_PROMOTOR', promotor)
      this.$store.commit('SET_SHOW_ATTACH_PROMOTOR_URL_DIALOG', true)
    },
    showEditPromotor (promotor) {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PROMOTOR', 'edit')
      this.$store.commit('SET_NEW_EDIT_PROMOTOR_OBJ', { ...promotor })
      this.showNewEditPromotorDialog = true
    },
    showOneTimePassword (user) {
      // this.$store.dispatch('getUser', {userId: user.UUID})
      // this.showOneTimePasswordDialog = true
    },
    showChangePasswordUser (user) {
      this.selectedUser = user.UUID
      this.showChangePasswordUserDialog = true
    },
    showDeletePromotor (promotor) {
      this.$store.commit('SET_SELECTED_PROMOTOR', promotor)
      this.showDeletePromotorDialog = true
    }

  },
  mixins: [TimeZones],
  watch: {
    // 'advancedSearch.usersLikings.or': function () {
    //   this.getUsers()
    // },
    // 'advancedSearch.spotifyGenres.or': function () {
    //   this.getUsers()
    // },
    // 'advancedSearch.roles': function () {
    //   this.getUsers()
    // },
    // 'advancedSearch.verified': function () {
    //   this.getUsers()
    // },
    // 'advancedSearch.extradata': function () {
    //   this.getUsers()
    // },
    // 'advancedSearch.imported': function () {
    //   this.getUsers()
    // },
    optionsPromotors: {
      handler () {
        this.getPromotors()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.optionsPromotors.page = 1
      this.getUsers()
    }
  }
}
</script>
